import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, ShieldCheck } from "lucide-react";
import { BUSINESS } from "../../data/business";

export default function TopBanner() {
  return (
    <div className="hidden min-[920px]:block bg-[#1A1D21] text-white text-[13px]" data-testid="top-banner">
      <div className="abc-container py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-5 text-white/90">
          <a href={BUSINESS.phoneHref} className="inline-flex items-center gap-1.5 hover:text-white transition" data-testid="topbar-phone">
            <Phone className="w-3.5 h-3.5 text-[#E31D2B]" /> {BUSINESS.phone}
          </a>
          <a href={BUSINESS.emailHref} className="inline-flex items-center gap-1.5 hover:text-white transition" data-testid="topbar-email">
            <Mail className="w-3.5 h-3.5 text-[#54616E]" /> {BUSINESS.email}
          </a>
          <Link to="/service-areas" className="inline-flex items-center gap-1.5 hover:text-white transition" data-testid="topbar-service-areas">
            <MapPin className="w-3.5 h-3.5 text-[#54616E]" /> Service Areas
          </Link>
        </div>
        <div className="flex items-center gap-5 text-white/90">
          <span className="inline-flex items-center gap-1.5">
            <ShieldCheck className="w-3.5 h-3.5 text-[#E31D2B]" />
            Licensed &amp; Insured · {BUSINESS.hours.weekdays}
          </span>
          <a href={BUSINESS.social.instagram} aria-label="Instagram" target="_blank" rel="noreferrer" className="hover:text-white transition" data-testid="topbar-instagram">
            <Instagram className="w-4 h-4" />
          </a>
          <a href={BUSINESS.social.facebook} aria-label="Facebook" target="_blank" rel="noreferrer" className="hover:text-white transition" data-testid="topbar-facebook">
            <Facebook className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  );
}
